'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('../../styled/components');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

exports.default = function (_ref) {
  var style = _ref.style;
  return _react2.default.createElement(_components.ThemedSvg, {
    width: '142px',
    height: '142px',
    viewBox: '0 0 142 142',
    style: style,
    version: '1.1',
    xmlns: 'http://www.w3.org/2000/svg'
  }, _react2.default.createElement('g', {
    id: 'project-list-1200',
    stroke: 'none',
    strokeWidth: '1'
  }, _react2.default.createElement('g', {
    id: '120.4-Project-all-no-content',
    transform: 'translate(-591.000000, -411.000000)'
  }, _react2.default.createElement('g', {
    id: 'Group-50',
    transform: 'translate(588.000000, 412.000000)'
  }, _react2.default.createElement('g', {
    id: 'Group-35',
    transform: 'translate(4.000000, 0.000000)'
  }, _react2.default.createElement('g', {
    id: 'file-(2)',
    transform: 'translate(46.000000, 40.000000)',
    fillRule: 'nonzero'
  }, _react2.default.createElement('path', {
    d: 'M39,25 L14,25 C13.448,25 13,25.447 13,26 C13,26.553 13.448,27 14,27 L39,27 C39.552,27 40,26.553 40,26 C40,25.447 39.552,25 39,25 Z',
    id: 'Shape'
  }), _react2.default.createElement('path', {
    d: 'M14,19 L24,19 C24.552,19 25,18.553 25,18 C25,17.447 24.552,17 24,17 L14,17 C13.448,17 13,17.447 13,18 C13,18.553 13.448,19 14,19 Z',
    id: 'Shape'
  }), _react2.default.createElement('path', {
    d: 'M39,33 L14,33 C13.448,33 13,33.447 13,34 C13,34.553 13.448,35 14,35 L39,35 C39.552,35 40,34.553 40,34 C40,33.447 39.552,33 39,33 Z',
    id: 'Shape'
  }), _react2.default.createElement('path', {
    d: 'M39,41 L14,41 C13.448,41 13,41.447 13,42 C13,42.553 13.448,43 14,43 L39,43 C39.552,43 40,42.553 40,42 C40,41.447 39.552,41 39,41 Z',
    id: 'Shape'
  }), _react2.default.createElement('path', {
    d: 'M39,49 L14,49 C13.448,49 13,49.447 13,50 C13,50.553 13.448,51 14,51 L39,51 C39.552,51 40,50.553 40,50 C40,49.447 39.552,49 39,49 Z',
    id: 'Shape'
  }), _react2.default.createElement('path', {
    d: 'M43,14.586 L43,0 L0,0 L0,55 L5,55 L5,60 L48,60 L48,19.586 L43,14.586 Z M34,8.414 L43,17.414 L44.586,19 L34,19 L34,8.414 Z M2,53 L2,2 L41,2 L41,12.586 L33.414,5 L5,5 L5,53 L2,53 Z M7,58 L7,55 L7,7 L32,7 L32,21 L46,21 L46,58 L7,58 Z',
    id: 'Shape'
  })))))));
};